// Phase 2 §2: FundingScenarios with Banner and Mode Toggle
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { ScenarioWorkbench } from '@/components/ledger/ScenarioWorkbench';
import { CapTableReconciliation } from '@/components/ledger/CapTableReconciliation';
import { CapTableTimeline } from '@/components/ledger/CapTableTimeline';
import ValuationAdvisor from '@/components/ledger/ValuationAdvisor';
import RoundDesigner from '@/components/ledger/RoundDesigner';
import { useTenantStore } from '@/hooks/useTenantStore';
import { ScenarioProjectionBanner } from '@/components/ledger/ScenarioProjectionBanner';
import { CapTableModeToggle } from '@/components/ledger/CapTableModeToggle';
import { ProjectionComparisonDrawer } from '@/components/ledger/ProjectionComparisonDrawer';

const FundingScenarios = () => {
  const { tenantId } = useTenantStore();

  return (
    <>
      <ScenarioProjectionBanner />
      <DashboardLayout>
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold tracking-tight">Funding Scenarios</h1>
              <p className="text-muted-foreground">
                Model dilution, SAFE conversions, option pools, and exit waterfalls
              </p>
            </div>
            <div className="flex items-center gap-3">
              {tenantId && <ProjectionComparisonDrawer companyId={tenantId} />}
              <CapTableModeToggle />
            </div>
          </div>

          {tenantId ? (
            <>
              <ValuationAdvisor companyId={tenantId} />
              {/* The only caller of apply_round, and nothing rendered it — so the
                  one path that writes a priced round to the cap table was
                  unreachable from the application. */}
              <RoundDesigner companyId={tenantId} />
              <ScenarioWorkbench companyId={tenantId} />
              <CapTableReconciliation companyId={tenantId} />
              <CapTableTimeline companyId={tenantId} />
            </>
          ) : (
            <div className="text-center text-muted-foreground py-8">
              Please select a company to run scenarios
            </div>
          )}
        </div>
      </DashboardLayout>
    </>
  );
};

export default FundingScenarios;
